/* Optional product UI. The original form and checkout never wait for these files. */
(() => {
  'use strict';
  if (window.zbProductEnhancementsLoader) return;
  window.zbProductEnhancementsLoader = true;
  const stickyURL = document.currentScript?.dataset.stickyScript;

  function init() {
    const config = document.getElementById('zb-social-preview-config');
    const previewEvents = new AbortController(), stickyEvents = new AbortController();
    const composing = new WeakSet();
    if (config) config.zbComposingInputs = composing;
    let previewPending = false, stickyPending = false;

    function load(kind) {
      const preview = kind === 'preview';
      if (preview ? previewPending || window.zbSocialPreviewLoaded : stickyPending || window.zbStickyOrderInstalled) return;
      const url = preview ? config?.dataset.script : stickyURL;
      if (!url) return;
      if (preview) previewPending = true;
      else stickyPending = true;
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.addEventListener('load', () => {
        (preview ? previewEvents : stickyEvents).abort();
        if (preview && config) delete config.zbComposingInputs;
      }, { once:true });
      script.addEventListener('error', () => {
        // A later interaction may retry the script; never retry a paid API call here.
        if (preview) previewPending = false;
        else stickyPending = false;
        script.remove();
      }, { once:true });
      document.head.appendChild(script);
    }

    function kind(input) {
      if (!(input instanceof HTMLInputElement) || !['text', 'url'].includes(input.type)) return '';
      const name = input.name || '';
      if (!/properties\[|\[properties\]/.test(name) || /autor|treść|uwag|komentarza/i.test(name)) return '';
      if (/PROFIL|KANAŁ/.test(name) || input.hasAttribute('data-profile')) return 'profile';
      return /LINK\s*\d*\]/.test(name) || input.hasAttribute('data-zb-url') || input.hasAttribute('data-link') || input.classList.contains('st-dynamic-link') ? 'publication' : '';
    }

    function prepareFields() {
      if (!config || window.zbSocialPreviewLoaded) return;
      for (const input of document.querySelectorAll('input')) {
        const type = kind(input);
        if (!type) continue;
        if (!input.disabled && (input.value.trim() || input === document.activeElement)) load('preview');
        if (type !== 'profile' || input.value.trim()) continue;
        // Match the existing empty profile field without mounting its full controller.
        const wrapper = input.closest('.ig-input-wrapper,.tt-input-wrapper,.fb-input-wrapper,.yt-input-wrapper,.st-input-wrapper');
        if (!wrapper) continue;
        wrapper.classList.add('zb-preview-field');
        wrapper.dataset.zbPreviewKind = 'profile';
        wrapper.dataset.zbPreviewState = 'empty';
        wrapper.setAttribute('aria-busy', 'false');
        let parent = input.parentElement;
        for (let i = 0; i < 4 && parent && parent.id !== 'MainContent'; i++, parent = parent.parentElement) {
          const status = parent.querySelector('.ig-status-selected,.tt-status-selected,.fb-status-selected,.yt-status-selected,[data-profile-status]');
          if (status) {
            status.classList.add('zb-preview-status');
            status.dataset.zbPreviewStatus = 'empty';
            break;
          }
        }
      }
    }

    if (config) {
      const previewIntent = event => {
        const target = event.target;
        const input = target instanceof HTMLInputElement ? target : target.closest?.('.ig-input-wrapper,.tt-input-wrapper,.fb-input-wrapper,.yt-input-wrapper,.st-input-wrapper')?.querySelector('input');
        if (kind(input) && !input.disabled) load('preview');
      };
      for (const type of ['focusin', 'pointerdown', 'input', 'change', 'paste']) {
        document.addEventListener(type, previewIntent, { signal:previewEvents.signal });
      }
      document.addEventListener('compositionstart', event => {
        if (!kind(event.target)) return;
        composing.add(event.target);
        load('preview');
      }, { signal:previewEvents.signal });
      document.addEventListener('compositionend', event => composing.delete(event.target), { signal:previewEvents.signal });
      window.addEventListener('pageshow', prepareFields, { signal:previewEvents.signal });
      prepareFields();
    }

    const stickyIntent = () => load('sticky');
    for (const type of ['wheel', 'touchstart']) window.addEventListener(type, stickyIntent, { passive:true, signal:stickyEvents.signal });
    const checkScroll = () => { if (window.scrollY > 0) stickyIntent(); };
    window.addEventListener('scroll', checkScroll, { passive:true, signal:stickyEvents.signal });
    window.addEventListener('pageshow', checkScroll, { signal:stickyEvents.signal });
    document.addEventListener('pointerdown', event => {
      if (event.target.closest?.('product-info[id^="MainProduct-"]')) stickyIntent();
    }, { signal:stickyEvents.signal });
    document.addEventListener('keydown', event => {
      if (['PageDown', 'End', ' ', 'ArrowDown'].includes(event.key) && !event.target.closest?.('input,textarea,select,[contenteditable="true"]')) stickyIntent();
    }, { signal:stickyEvents.signal });
    checkScroll();
    if (window.Shopify?.designMode) { load('preview'); load('sticky'); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
